const selectElements = document.getElementsByClassName("radio__input");
 
Array.from(selectElements).forEach((selectElement) => {
    selectElement.addEventListener("click", (event) => {
        var oldVariant = document.getElementsByClassName("axt-cp-custom")[0].getAttribute("axt-cp-variant-id");
 
        setTimeout(() => {
            var variantId = document.querySelector('[name="id"]').value;
            var customElement = document.getElementsByClassName("axt-cp-custom")[0];
                console.log(oldVariant, "-->oldVariant")
                console.log(variantId, "-->variantId")
            customElement.classList.remove(oldVariant); 
            customElement.classList.add(variantId);
            customElement.setAttribute("axt-cp-variant-id", variantId);
        }, 300);
    });
});